export default "__VITE_ASSET__c4d1e4ff__"